<template>
  <div class="base-text" :style="style" :class="[props.noSelection ? 'no-selection': '']">
        <slot></slot>
    <required-tag-text v-if="props.requiredTag || props.primaryRequiredTag" :color="props.primaryRequiredTag? 'primary' : 'error'">必須</required-tag-text>
  </div>
</template>

<script lang="ts" setup>

import { computed, CSSProperties } from 'vue';
import { Colors } from '@/store/theme.store';
import { useTheme } from '@/composable/ui/useTheme';
import RequiredTagText from '@/components/Texts/RequiredTagText.vue';
import { useBreakpoint } from '@/composable/ui/useScreen';
import FlexLayout from "@/components/Layouts/FlexLayout.vue";

const theme = useTheme();
const breakpoint = useBreakpoint();
const props = defineProps({
  size: {
    type: String as() => 'xxs' |'xs' |'sm' | 'md' | 'lg' | 'xlg' | 'xxlg',
    default: 'md',
  },
  bold: Boolean,
  underline: Boolean,
  color: { type: String as () => keyof Colors, default: 'body' },
  justify: {
    type: String as () => 'start' | 'center' | 'end',
    default: 'start',
  },
  requiredTag: {
    type: Boolean,
    default: false,
  },
  primaryRequiredTag: {
    type: Boolean,
    default: false,
  },
  noWrap: Boolean,
  noSelection: Boolean,
  minHeight: {
    type: Number,
    required: false,
  },
  verticalAlignCenter: Boolean,
});

const sizes = {
  xxs: 10,
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xlg: 25,
  xxlg: 28,
};

const mobileSizes = {
  xxs: 10,
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xlg: 25,
  xxlg: 28
};

const textAligns = {
  start: 'left',
  center: 'center',
  end: 'right',
};

const style = computed((): CSSProperties => ({
  'font-size': `${breakpoint.smAndDown ? mobileSizes[props.size] : sizes[props.size]}px`,
  minHeight: props.minHeight != null ? `${props.minHeight}px` : `${sizes[props.size] + 10}px`,
  fontWeight: props.bold ? 700 : 400,
  color: theme.resolveColor(props.color),
  textAlign: textAligns[props.justify] as CSSProperties['textAlign'],
  whiteSpace: props.noWrap ? 'nowrap' : 'pre-wrap',
  textDecoration: props.underline ? 'underline' : 'none',
  textUnderlineOffset: `0.2rem `,
  alignContent: props.verticalAlignCenter ? 'center' : undefined
}));

</script>

<style scoped>
div {
  letter-spacing: 1px;
  text-align: left;
  word-break: break-word;
}

.no-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
